/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
  					path => router path
  					name => router name
  					component(lazy loading) => component to load
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Version: 1.1
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export const router = new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: "",
      component: () => import("./layouts/main/Main.vue"),
      children: [
        {
          path: "/",
          name: "home",
          component: () => import("./views/Dashboard.vue")
        },
        {
          path: "/exercicios",
          name: "exercicios",
          component: () => import("./views/zpages/Exercicios.vue")
        },
        /* {
          path: "/zpoints",
          name: "zpoints",
          component: () => import("./views/zpages/zPoints.vue"),
          meta: {
            breadcrumb: [
              { title: "Início", url: "/" },
              { title: "zPoints", active: true }
            ],
            pageTitle: "zPoints",
            rule: "student"
          }
        }, */
        {
          path: "/quests",
          name: "quests",
          component: () => import("./views/zpages/Quests.vue"),
          meta: {
            breadcrumb: [
              { title: "Início", url: "/" },
              { title: "Quests", active: true }
            ],
            pageTitle: "Quests",
            rule: "student"
          }
        },
        {
          path: "/quest/:id",
          name: "quest",
          component: () => import("./views/zpages/Quest.vue"),
          meta: {
            breadcrumb: [
              { title: "Início", url: "/" },
              { title: "Quests", url: "/quests" },
              { title: "Quests #", active: true }
            ],
            pageTitle: "Quest #",
            rule: "student"
          }
        },
        {
          path: "/conquistas",
          name: "conquistas",
          component: () => import("./views/zpages/Conquistas.vue"),
          meta: {
            breadcrumb: [
              { title: "Início", url: "/" },
              { title: "Conquistas", active: true }
            ],
            pageTitle: "Conquistas",
            rule: "student"
          }
        },
        /* {
          path: "/ziongold",
          name: "ziongold",
          component: () => import("./views/zpages/ZionGold.vue"),
          meta: {
            breadcrumb: [
              { title: "Início", url: "/" },
              { title: "ZION Gold", active: true }
            ],
            pageTitle: "ZION Gold",
            rule: "student"
          }
        }, */
        {
          path: "/avaliaraula",
          name: "avaliaraula",
          component: () => import("./views/zpages/ClassEvaluation.vue"),
          meta: {
            breadcrumb: [
              { title: "Início", url: "/" },
              { title: "Avaliar Aula", active: true }
            ],
            pageTitle: "Avaliar Aula",
            rule: "student"
          }
        },
        {
          path: "/module-group/:id",
          name: "modulegroup",
          component: () => import("./views/zpages/Modulos.vue"),
          meta: {
            breadcrumb: [
              { title: "Início", url: "/" },
              { title: "Núcleo" },
              { title: "Núcleo #", active: true }
            ],
            pageTitle: "Núcleo",
            rule: "student"
          }
        },
        {
          path: "/course_plan/:id",
          name: "course_plan",
          component: () => import("./views/zpages/CoursePlan.vue"),
          meta: {
            breadcrumb: [
              { title: "Início", url: "/" },
              { title: "Plano de Curso"},
              { title: "Módulo", active: true }
            ],
            pageTitle: "Plano de curso",
            rule: "student"
          }
        },
        {
          path: "/digital-contents",
          name: "digital_contents",
          component: () => import("./views/zpages/DigitalContents.vue"),
          props: { content_type: 'digital-contents' },
          meta: {
            breadcrumb: [
              { title: "Início", url: "/" },
              { title: "Conteúdos digitais", active: true}
            ],
            pageTitle: "Conteúdos digitais",
            rule: "student"
          }
        },
        {
          path: "/digital-contents/:id",
          name: "digital_content",
          component: () => import("./views/zpages/DigitalContent.vue"),
          props: { content_type: 'digital-contents' },
          meta: {
            breadcrumb: [
              { title: "Início", url: "/" },
              { title: "Conteúdo digital", active: true}
            ],
            pageTitle: "Conteúdo digital",
            rule: "student"
          }
        },
        {
          path: "/video-lessons",
          name: "video_lessons",
          component: () => import("./views/zpages/DigitalContents.vue"),
          props: { content_type: 'video-lessons' },
          meta: {
            breadcrumb: [
              { title: "Início", url: "/" },
              { title: "Vídeo aulas", active: true}
            ],
            pageTitle: "Vídeo aulas",
            rule: "student"
          }
        },
        {
          path: "/video-lessons/:id",
          name: "video_lesson",
          component: () => import("./views/zpages/DigitalContent.vue"),
          props: { content_type: 'video-lessons' },
          meta: {
            breadcrumb: [
              { title: "Início", url: "/" },
              { title: "Vídeo Aula", active: true}
            ],
            pageTitle: "Vídeo Aula",
            rule: "student"
          }
        },
        {
          path: "/class-chat/",
          name: "class_chat",
          component: () => import("./views/zpages/ClassChat.vue"),
          props: { content_type: 'class-chat' },
          meta: {
            breadcrumb: [
              { title: "Início", url: "/" },
              { title: "Turma", active: true}
            ],
            pageTitle: "Turma",
            rule: "student"
          }
        }
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: "",
      component: () => import("@/layouts/full-page/FullPage.vue"),
      children: [
        {
          path: "/login",
          name: "pageLogin",
          component: () => import("@/views/zpages/Login.vue")
        },
        {
          path: "/error-404",
          name: "pageError404",
          component: () => import("@/views/pages/404.vue")
        }
      ]
    },
    {
      path: "*",
      redirect: "/error-404"
    }
  ]
});

// router.afterEach(
//   function() {
//     Vue.$vs.loading.close();
//   }.bind(this)
// );

// router.beforeResolve(
//   function(to, from, next) {
//     console.log(Vue.loading);
//     if (to.name) {
//       Vue.$vs.loading();
//     }
//     next();
//   }.bind(this)
// );

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ["/login"];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem("user");

  if (authRequired && !loggedIn) {
    return next("/login");
  }
  next();
});
